import React, {Component} from 'react';
import Header from "../components/Header/Header";
import bg from '../assets/img/affBG.jpg';
import Description from "../components/Affiliations/Description";
import FirstAffiliate from "../components/Affiliations/FirstAffiliate";
import SecondAffiliate from "../components/Affiliations/SecondAffiliate";
import AffiliationLogos from "../components/Affiliations/AffiliationLogos";

import hngutils from "../assets/libs/hngutils";

class Affiliations extends Component {
    constructor(props) {
      super(props);

      this.props.data.affiliateData.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.logo);
        hngutils.imageSrcToLocalFile(edge.node.acf.side_image);
      });

      this.props.data.logos.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.logo);
      });
    }

    render() {
        const affiliateData = this.props.data.affiliateData.edges;
        const affiliateLogos = this.props.data.logos.edges;
        const {content, acf: {header, subheader}} = this.props.data.header.edges[0].node;
        return (
          <div>
              <Header
                title={header}
                bg={bg}
              />
              <Description
                header={subheader}
                paragraph={content}
              />
              <FirstAffiliate affiliate={affiliateData[0]}/>
              <SecondAffiliate affiliate={affiliateData[1]}/>
              <AffiliationLogos logos={affiliateLogos}/>
          </div>
        )
    }
};

export default Affiliations

// affiliate parent = 462

export const affiliationsQuery = graphql`
    query affiliationsQuery {
        header: allWordpressPage(filter: {wordpress_id: {eq: 629}}) {
            edges {
                node {
                    title
                    content
                    acf {
                        header
                        subheader
                    }
                }
            }
        }
        affiliateData: allWordpressPage(filter:{wordpress_parent:{eq: 462}}, sort:{fields: [date]}) {
            edges {
                node {
                    acf {
                        header
                        paragraph
                        name
                        description
                        acronym
                        mission_text
                        logo{
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }
                        }
                        side_image {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }
                        }
                    }
                }
            }
        }
        logos: allWordpressPost(filter:{acf:{type:{eq:"affiliate"}}}) {
            edges {
                node {
                    acf {
                        name
                        link
                        logo {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }
                        }
                    }
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/affiliations.js